/**
 * RTL Language Detection Utility
 * 
 * Supported RTL languages:
 * - Arabic (ar)
 */

export const RTL_LANGUAGES = ['ar'] as const

export type RTLLanguage = typeof RTL_LANGUAGES[number]

/**
 * Check if a locale code is an RTL language
 * @param locale - The locale code (e.g., 'en', 'ar')
 * @returns true if the locale is RTL, false otherwise
 */
export function isRTLLocale(locale: string): boolean {
    return RTL_LANGUAGES.includes(locale as RTLLanguage)
}
